import { render, staticRenderFns } from "./TranProgramProgramModuleCreate.vue?vue&type=template&id=980dc2a2"
import script from "./TranProgramProgramModuleCreate.vue?vue&type=script&lang=js"
export * from "./TranProgramProgramModuleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports